<template>
    <div class="submitGpsMain">
        <div v-if="userIsBlock && !showSuccess" class="alert alert-danger" role="alert">
            {{ errorMessage ? errorMessage : defaultErrorMessage }}
        </div>

        <div v-if="!userIsBlock && showSuccess" class="alert alert-success" role="alert">
            {{ successMessage ? successMessage : defaultSuccessMessage }}
        </div>

        <form v-if="!showSuccess" @submit.prevent="save">
            <label for="name" class="form-label">Your Full Name</label>
            <input
                id="name"
                type="text"
                class="form-control mb-3"
                autocomplete="off"
                v-model="name"
            />
            <button
                type="submit"
                class="btn btn-primary w-full"
                :disabled="loading || !name || !reservation"
            >
                <span v-if="!loading">Save</span><span v-else>Wait...</span>
            </button>
        </form>
    </div>
</template>

<script>

import {mapActions} from "vuex";

export default {
    name: "SubmitGps",

    props: [
        "reservation"
    ],

    data: function() {
        return {
            name: '',
            loading: false,
            lat: 0,
            lng: 0,
            userIsBlock: false,
            showSuccess: false,
            errorMessage: '',
            defaultErrorMessage: 'You denied location tracking!',
            successMessage: '',
            defaultSuccessMessage: 'Success! You can close this window!'
        };
    },

    watch: {
        name() {
            this.userIsBlock = false;
            this.errorMessage = ''
        }
    },

    mounted() {
        this.setMyLocation();
    },

    methods: {
        ...mapActions('app', ['storeUserLocation']),
        async save() {
            if (this.lat === 0 || this.lng === 0) {
                this.errorMessage = 'Something wrong with coordinates - reload page.'
                this.userIsBlock = true;
                return;
            }

            this.loading = true;
            this.errorMessage = '';
            const response = await this.storeUserLocation({
                name: this.name,
                lat: this.lat,
                lng: this.lng,
                reservation: this.reservation
            })
            if (!response.data.status) {
                this.errorMessage = response.data.message ? response.data.message : 'Something went wrong. Please, reload page.'
                this.userIsBlock = true;
            } else {
                this.successMessage = response.data.message ? response.data.message : '';
                this.showSuccess = true;
            }
            this.loading = false;
        },

        setMyLocation: function() {
            const self = this;
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    this.showPosition,
                    function(e) {
                        self.userIsBlock = true;
                        console.log(
                            "Error.code: " +
                            e.code +
                            " Error.message: " +
                            e.message
                        );
                    }
                );
            }
        },

        showPosition: function(position) {
            this.lat = position.coords.latitude
            this.lng = position.coords.longitude
        },
    }
}

</script>
